import {
  API_APP_NAME,
  RequestMethod,
  SubscriptionListType,
} from '~/shared/constants'
import { ApiService } from '~/shared/services'
import {
  IRawSubscription,
  IRequestOptions,
  IResponseResult,
} from '~/shared/types'

export class SubscriptionsApi {
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  getSubscriptionList({
    cohort,
    type,
    uuid,
    tags = '',
  }: {
    cohort: string
    type: SubscriptionListType
    uuid: string
    tags?: string
  }): Promise<IResponseResult<{ prices: IRawSubscription }>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      params: { plan_type: type, uuid, tags },
    }

    return this.api.makeRequest<{ plans: IRawSubscription }>(
      `v2/plans/${API_APP_NAME}/${cohort}`,
      options,
    )
  }
}
